
import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { ChevronRight } from "lucide-react";

const Landing = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 to-indigo-100">
      <header className="border-b bg-white/80 backdrop-blur-sm sticky top-0 z-50">
        <div className="container mx-auto px-4">
          <div className="flex items-center justify-between h-16">
            <div className="flex items-center gap-2">
              <img 
                src="/lovable-uploads/e6a8f262-43de-486d-8308-741e9a1916a0.png" 
                alt="Logo" 
                className="h-8 w-8"
              />
              <span className="font-semibold text-xl">Expensify</span>
            </div>
            <div className="flex items-center gap-4">
              <Button
                variant="ghost"
                onClick={() => navigate("/login")}
              >
                Sign In
              </Button>
              <Button
                onClick={() => navigate("/login")}
              >
                Get Started
              </Button>
            </div>
          </div>
        </div>
      </header>

      <main>
        <section className="pt-20 pb-32">
          <div className="container mx-auto px-4">
            <div className="max-w-3xl mx-auto text-center space-y-8">
              <h1 className="text-5xl font-bold tracking-tight text-gray-900">
                Smart Expense Management for Modern Businesses
              </h1>
              <p className="text-xl text-gray-600">
                Streamline your expense tracking, automate reporting, and gain valuable insights into your business spending.
              </p>
              <div className="flex justify-center gap-4">
                <Button
                  size="lg"
                  onClick={() => navigate("/login")}
                  className="gap-2"
                >
                  Start Free Trial <ChevronRight className="h-4 w-4" />
                </Button>
              </div>
            </div>
          </div>
        </section>

        <section className="py-24 bg-white">
          <div className="container mx-auto px-4">
            <div className="grid md:grid-cols-3 gap-12">
              <div className="text-center space-y-4">
                <h3 className="text-xl font-semibold">Easy Expense Tracking</h3>
                <p className="text-gray-600">
                  Quickly log expenses, attach receipts, and categorize transactions.
                </p>
              </div>
              <div className="text-center space-y-4">
                <h3 className="text-xl font-semibold">Automated Reports</h3>
                <p className="text-gray-600">
                  Generate detailed reports automatically and share them with stakeholders.
                </p>
              </div>
              <div className="text-center space-y-4">
                <h3 className="text-xl font-semibold">Smart Analytics</h3>
                <p className="text-gray-600">
                  Get insights into spending patterns and make informed decisions.
                </p>
              </div>
            </div>
          </div>
        </section>
      </main>
    </div>
  );
};

export default Landing;
